export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILURE = "GET_SETTINGS_FAILURE";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_FAILURE = "GET_USER_DATA_FAILURE";
export const INCREMENT_STEP = "INCREMENT_STEP";
export const INCREMENT_STEP_SUCCESS = "INCREMENT_STEP_SUCCESS";
export const INCREMENT_STEP_FAILURE = "INCREMENT_STEP_FAILURE";
export const GET_REASONS_SUCCESS = "GET_REASONS_SUCCESS";
export const GET_REASONS_FAILURE = "GET_REASONS_FAILURE";
export const CHOOSE_REASONS_SUCCESS = "CHOOSE_GREASONS_SUCCESS";
export const CHOOSE_REASONS_FAILURE = "CHOOSE_REASONS_FAILURE";
export const SET_DETAILS_SUCCESS = "SET_DETAILS_SUCCESS";
export const SET_DETAILS_FAILURE = "SET_DETAILS_FAILURE";
export const SET_ABOUT_SUCCESS = "SET_ABOUT_SUCCESS";
export const SET_ABOUT_FAILURE = "SET_ABOUT_FAILURE";
export const GET_INTERESTS_SUCCESS = "GET_INTERESTS_SUCCESS";
export const GET_INTERESTS_FAILURE = "GET_INTERESTS_FAILURE";
export const CHOOSE_INTERESTS_SUCCESS = "CHOOSE_INTERESTS_SUCCESS";
export const CHOOSE_INTERESTS_FAILURE = "CHOOSE_INTERESTS_FAILURE";
export const GET_AGE_SUCCESS = "GET_AGE_SUCCESS";
export const GET_AGE_FAILURE = "GET_AGE_FAILURE";
export const CHOOSE_AGE_SUCCESS = "CHOOSE_AGE_SUCCESS";
export const CHOOSE_AGE_FAILURE = "CHOOSE_AGE_FAILURE";
export const GET_DIVERSITY_SUCCESS = "GET_DIVERSITY_SUCCESS";
export const GET_DIVERSITY_FAILURE = "GET_DIVERSITY_FAILURE";
export const CHOOSE_DIVERSITY_SUCCESS = "CHOOSE_DIVERSITY_SUCCESS";
export const CHOOSE_DIVERSITY_FAILURE = "CHOOSE_DIVERSITY_FAILURE";
export const GET_MEMBERSHIPS_SUCCESS = "GET_MEMBERSHIPS_SUCCESS";
export const GET_MEMBERSHIPS_FAILURE = "GET_MEMBERSHIPS_FAILURE";
export const CHOOSE_MEMBERSHIP_SUCCESS = "CHOOSE_MEMBERSHIP_SUCCESS";
export const CHOOSE_MEMBERSHIP_FAILURE = "CHOOSE_MEMBERSHIP_FAILURE";
export const GET_CREDIT_CARD_SUCCESS = "GET_CREDIT_CARD_SUCCESS";
export const GET_CREDIT_CARD_FAILURE = "GET_CREDIT_CARD_FAILURE";
export const SET_CREDIT_CARD_SUCCESS = "SET_CREDIT_CARD_SUCCESS";
export const SET_CREDIT_CARD_FAILURE = "SET_CREDIT_CARD_FAILURE";
export const DELETE_CREDIT_CARD_SUCCESS = "DELETE_CREDIT_CARD_SUCCESS";
export const DELETE_CREDIT_CARD_FAILURE = "DELETE_CREDIT_CARD_FAILURE";
export const GET_BILLING_ADDRESS_SUCCESS = "GET_BILLING_ADDRESS_SUCCESS";
export const GET_BILLING_ADDRESS_FAILURE = "GET_BILLING_ADDRESS_FAILURE";
export const SET_BILLING_ADDRESS_SUCCESS = "SET_BILLING_ADDRESS_SUCCESS";
export const SET_BILLING_ADDRESS_FAILURE = "SET_BILLING_ADDRESS_FAILURE";
export const GET_TERMS_AND_CONDITIONS_SUCCESS =
  "GET_TERMS_AND_CONDITIONS_SUCCESS";
export const GET_TERMS_AND_CONDITIONS_FAILURE =
  "GET_TERMS_AND_CONDITIONS_FAILURE";
export const ACCEPT_TERMS_AND_CONDITIONS_SUCCESS =
  "ACCEPT_TERMS_AND_CONDITIONS_SUCCESS";
export const ACCEPT_TERMS_AND_CONDITIONS_FAILURE =
  "ACCEPT_TERMS_AND_CONDITIONS_FAILURE";
export const RESEND_VERIFICATION_MESSAGE_SUCCESS =
  "RESEND_VERIFICATION_MESSAGE_SUCCESS";
export const RESEND_VERIFICATION_MESSAGE_FAILURE =
  "RESEND_VERIFICATION_MESSAGE_FAILURE";
export const DELETE_DATA = "DELETE_DATA";
